<mat-form-field appearance="outline" class="hide-error white-bg-field">
    <mat-label>{{ label | translate }}</mat-label>
    <input matInput type="text" (input)="search($event)"/>
    <lucide-icon matPrefix color="#b1b3b6" name="search" size="18" class="mx-2"></lucide-icon>
</mat-form-field>